import { Box } from '@apia/theme';
import { observer } from 'mobx-react-lite';
import { Attachments } from './Attachments';
import { MessageBlocks } from './MessageBlocks';
import { ChatMessage } from './ChatMessage';

export const Message = observer(
  ({
    className,
    message,
  }: {
    className?: string;
    message: ChatMessage;
  }) => {
    const content = message.message;
    const type = message.messageType;
    const attachments = message.attachments;
    const reference = message.reference;

    return (
      <Box
        className={`history_message ${className || ''} ${type}`}
        key={message.id}
      >
        <Box className="history_message__content message__body markdown">
          {typeof content === 'string' ? (
            <MessageBlocks
              streamParts={[{ blockType: 'text', str: content }]}
            ></MessageBlocks>
          ) : (
            content
          )}
        </Box>
        {attachments.length > 0 && (
          <Attachments attachments={attachments}></Attachments>
        )}
        {reference && (
          <Box className="history_message__references">{reference}</Box>
        )}
      </Box>
    );
  },
);
